export const informationCardDataSelector = state => state.informationCard.informationCardData;
export const informationCardErrorSelector = state => state.informationCard.error;
export const isInformationCardLoadingSelector = state => state.informationCard.isLoading;
